package com.fantasytenis.web.screens.auth

import androidx.compose.runtime.*
import com.fantasytenis.web.components.Button
import com.fantasytenis.web.components.TextField
import com.fantasytenis.web.di.DependencyContainer
import com.fantasytenis.web.theme.Colors
import com.fantasytenis.web.theme.h2Style
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LoginScreen(
    onLoginSuccess: () -> Unit,
    onNavigateToRegister: () -> Unit
) {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }

    val scope = rememberCoroutineScope()

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("min-height", "var(--app-height)")
            padding(24.px)
            overflowY("auto")
            property("-webkit-overflow-scrolling", "touch")
        }
    }) {
        Div({
            style {
                backgroundColor(Colors.Surface)
                borderRadius(12.px)
                padding(48.px)
                property("box-shadow", "0 4px 6px rgba(0, 0, 0, 0.1)")
                width(100.percent)
                maxWidth(400.px)
            }
        }) {
            // Logo/Title
            Div({
                style {
                    textAlign("center")
                    marginBottom(32.px)
                }
            }) {
                H2({
                    style {
                        h2Style()
                        color(Colors.Primary)
                        marginBottom(4.px)
                    }
                }) {
                    Text("Baseline")
                }
                P({
                    style {
                        fontSize(14.px)
                        color(Colors.TextSecondary)
                        fontWeight(400)
                    }
                }) {
                    Text("Fantasy Tennis")
                }
            }

            // Email Field
            TextField(
                value = email,
                onValueChange = { email = it },
                label = "Email",
                type = "email",
                placeholder = "Enter your email"
            )

            // Password Field
            TextField(
                value = password,
                onValueChange = { password = it },
                label = "Password",
                type = "password",
                placeholder = "Enter your password"
            )

            // Error Message
            error?.let { errorMessage ->
                P({
                    style {
                        color(Colors.Error)
                        fontSize(14.px)
                        marginBottom(16.px)
                        textAlign("center")
                    }
                }) {
                    Text(errorMessage)
                }
            }

            // Login Button
            Button(
                text = if (isLoading) "Signing in..." else "Sign In",
                onClick = {
                    if (!isLoading && email.isNotBlank() && password.isNotBlank()) {
                        isLoading = true
                        error = null

                        scope.launch {
                            DependencyContainer.loginUseCase(email, password)
                                .onSuccess {
                                    isLoading = false
                                    onLoginSuccess()
                                }
                                .onFailure { e ->
                                    isLoading = false
                                    error = e.message ?: "Login failed"
                                }
                        }
                    }
                },
                enabled = !isLoading && email.isNotBlank() && password.isNotBlank(),
                fullWidth = true
            )

            // Register Link
            P({
                style {
                    textAlign("center")
                    marginTop(24.px)
                    fontSize(14.px)
                    color(Colors.TextSecondary)
                }
            }) {
                Text("Don't have an account? ")
                A(
                    href = "#",
                    attrs = {
                        onClick { e ->
                            e.preventDefault()
                            onNavigateToRegister()
                        }
                        style {
                            color(Colors.Accent)
                            fontWeight(500)
                        }
                    }
                ) {
                    Text("Sign up")
                }
            }
        }
    }
}
